
const digest = '0fbbf7176d51d82b0a6fe22b2a558f5aa5edb6327ee5d9addfe5516ec4ad71ea';
const classes = {"subMenuContainer":"_subMenuContainer_1vtyi_1","horizontal":"_horizontal_1vtyi_13","horizontalMultiline":"_horizontalMultiline_1vtyi_13","vertical":"_vertical_1vtyi_17","menuOption":"_menuOption_1vtyi_26","selected":"_selected_1vtyi_41"};
const css = `._subMenuContainer_1vtyi_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  border-radius: 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 5px;
  width: fit-content;
  gap: 5px;
  margin: 0 auto;
  border: 1px solid #E9EDF3;
}

._horizontal_1vtyi_13, ._horizontalMultiline_1vtyi_13 {
  flex-direction: row;
}

._vertical_1vtyi_17 {
  flex-direction: column;
}

._horizontalMultiline_1vtyi_13 {
  flex-wrap: wrap;
  justify-content: space-around;
}

._menuOption_1vtyi_26 {
  background-color: transparent;
  color: #1665D8;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  flex: 0 0 auto;
}
._menuOption_1vtyi_26:hover {
  background-color: rgba(22, 101, 216, 0.1);
}
._menuOption_1vtyi_26._selected_1vtyi_41 {
  background-color: #1665D8;
  color: white;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  